// extracted by mini-css-extract-plugin
export default {"baseVideo":"BaseVideo_baseVideo__6x4Ju","content":"BaseVideo_content__o0t5Y"};